export default import.meta.ROLLDOWN_FILE_URL_fUwUaTj92Cg73JeOIXr4LA